import React from 'react'

const Account = () => {
  return (
    <div>Ac</div>
  )
}

export default Account